import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const HubSpotGate = React.lazy(() => import("./HubSpot.gate"));

const HubSpotLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <HubSpotGate />
  </React.Suspense>
);

export default () => <HubSpotLoadable />;
